export const ValidUrl = (url: any) => {
  try {
    if (
      url &&
      url.trim().length > 0 &&
      (url.trim().startsWith('http://') || url.trim().startsWith('https://'))
    )
      return url.length > 8;
  } catch {}

  return false;
};

export const GetParamObject = (query: any) => {
  if (query && query.startsWith('?') && query.length > 1) {
    var array = query.substring(1).split('&');

    if (array && array.length > 0) {
      var data = new Array();

      array.forEach((e: any) => {
        if (e && e.includes('=')) data.push(e.split('='));
      });

      if (data && data.length > 0) {
        var obj = data.reduce(function (acc, curr) {
          acc[curr[0]] = curr[1];
          return acc;
        }, {});

        if (obj) return obj;
      }
    }
  }
  return null;
};
